import { connect } from 'react-redux'

import {
  doAssignAgentToDraft,
  doAssignGroupToDraft,
  selectTicketDraftAssignedAgents,
  selectTicketDraftAssignedGroups,
  selectTicketDraftId,
} from 'ducks/drafts'

import { selectAgents } from 'selectors/agents/base'
import {
  selectSelectedGroup,
  selectSelectedGroupAgentsCount,
  selectSelectedAgent,
  selectIsFilteringPossibleAssignees,
  selectFilteredAgentsInSelectedGroup,
  selectFilteredAgentsInAllGroups,
  selectFilteredGroups,
  selectFilteredGroupsFromAgentFilter,
  selectSuggestedAgents,
} from 'selectors/assignments'
import { selectDraftAssigning } from 'selectors/modals_base'
import { selectIsInChat } from 'selectors/location'

import { batchActions } from 'util/redux'

import Menu from '../'

const select = state => ({
  allAgents: selectAgents(state),
  assignedAgents: selectTicketDraftAssignedAgents(state),
  assignedGroups: selectTicketDraftAssignedGroups(state),
  filteredAgents: selectFilteredAgentsInSelectedGroup(state),
  filteredAgentsAllGroups: selectFilteredAgentsInAllGroups(state),
  filteredGroups: selectFilteredGroups(state),
  filteredGroupsFromAgentFilter: selectFilteredGroupsFromAgentFilter(state),
  isFilteringPossibleAssignees: selectIsFilteringPossibleAssignees(state),
  isOpen: selectDraftAssigning(state),
  selectedAgent: selectSelectedAgent(state),
  selectedGroup: selectSelectedGroup(state),
  selectedGroupAgentsCount: selectSelectedGroupAgentsCount(state),
  suggestedAgents: selectSuggestedAgents(state),
  conversationIds: selectTicketDraftId(state),
  canShowPresence: selectIsInChat(state),
})

const perform = dispatch => ({
  onGroupSelect: (ticketId, groupId = null) => {
    dispatch(
      batchActions(
        doAssignAgentToDraft(ticketId, null),
        doAssignGroupToDraft(ticketId, groupId)
      )
    )
  },
  onAgentSelect: (ticketId, groupId, agentId) => {
    dispatch(
      batchActions(
        doAssignAgentToDraft(ticketId, agentId),
        doAssignGroupToDraft(ticketId, groupId)
      )
    )
  },
})

export default connect(select, perform)(Menu)
